import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function Search() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [items, setItems] = useState([]);
  useEffect(() => { if (q) api.get("/products", { params: { q, limit: 60 } }).then(r=>setItems(r.data.items)); }, [q]);
  return (
    <div className="max-w-7xl mx-auto px-6 py-12" data-testid="search-page">
      <div className="text-xs tracking-widest uppercase text-neutral-500 mb-2">Search results</div>
      <h1 className="font-display text-5xl text-[color:var(--hb-navy)] mb-6">"{q}"</h1>
      {items.length === 0 ? <p className="text-sm text-neutral-500">No results found.</p> :
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">{items.map(p=><ProductCard key={p.product_id} product={p}/>)}</div>}
    </div>
  );
}
